
<div class="tag" :class="tagClass" :style="'width: ' + this.width + 'px'">
    {{ label }}
</div>
